<h4 *ngIf="data && data.title">
  {{data.title}}
</h4>
<p *ngIf="data && data.message" [class]="data.textclass">
  {{data.message}}
</p>
<div class="text-right" *ngIf="showOk">
  <button mat-raised-button color="primary" (click)="close()">Ok</button>
</div>
